const authInterceptor = function authInterceptor($state, $injector) {
  'ngInject';

  function request(config) {
    const newConfig = { ...config };
    const Auth = $injector.get('Auth');
    const token = Auth.getToken();
    if (token) {
      newConfig.headers.authorization = `Bearer ${token}`;
    }
    return newConfig;
  }
  function responseError(rejection) {
    const rejectionStatus = [401, 403];
    if (rejectionStatus.indexOf(rejection.status) !== -1 && $state.current.name !== 'auth') {
      $state.go('auth');
      return Promise.resolve(rejection);
    }
    return Promise.reject(rejection);
  }
  return { request, responseError };
};
export default authInterceptor;



// WEBPACK FOOTER //
// ./client/app/components/auth/auth.interceptor.js